module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumbnail_GoWallet.b5da4245.jpg";